import React, { Component } from 'react';
import { Modal, Button, Icon, message } from 'antd';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import './style/sortList.less';

const SortFivItem = SortableElement(({ data }) => {
    return (
        <div className='sort-template-contain'>
            <div className="sort-template-header">{data.fieldName}</div>
        </div>
    )
});

const SortFivList = SortableContainer(({ data }) => {
    return (
        <div className="sort-wrap">
            {
                data.map((item, index) => (
                    <SortFivItem key={item.followBoardDetailId} index={index} data={item} />
                ))
            }
        </div>
    );
});


class SortFivWrap extends Component {
    onSortEnd = ({oldIndex, newIndex}) => {
        const { data, forIndex, changeForItem } = this.props;
        changeForItem(arrayMove(data, oldIndex, newIndex), forIndex);
    }

    render () {
        const { data } = this.props;
        return (
            <div className="sort-content">
                <SortFivList
                    axis="y"
                    lockAxis="y"
                    helperClass="sortHelper"
                    data={data}
                    hideSortableGhost={false}
                    lockToContainerEdges={true}
                    onSortEnd={this.onSortEnd}
                />
            </div>
        )
    }
}

class SortForItemDom extends Component {
    state = {
        isShow: true,
    }

    render () {
        const { isShow } = this.state;
        const { data, changeForItem, forIndex } = this.props;
        const hasChild = data.children ? (data.children.length > 0) : false;
        return (
            <div className='sort-template-contain'>
                <div className="sort-template-header" style={{ position: 'relative' }}>
                    {data.fieldName}
                    {
                       hasChild &&
                       <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                {
                   hasChild && isShow &&
                    <SortForWrap key={data.followBoardDetailId} changeForItem={changeForItem} forIndex={forIndex} data={data.children} />
                }
            </div>
        )
    }
}


const SortForItem = SortableElement(({ data, forIndex, changeForItem }) => {
    return (
        <SortForItemDom key={data.followBoardDetailId} changeForItem={changeForItem} forIndex={forIndex} data={data} />
    )
});

const SortForList = SortableContainer(({ data, changeForItem }) => {
    return (
        <div className="sort-wrap">
            {
                data.map((item, index) => (
                    <SortForItem key={item.followBoardDetailId} changeForItem={changeForItem} index={index} forIndex={index} data={item} />
                ))
            }
        </div>
    );
});


class SortForWrap extends Component {
    onSortEnd = ({oldIndex, newIndex}) => {
        const { data, thirIndex, changeThirItem } = this.props;
        changeThirItem(arrayMove(data, oldIndex, newIndex), thirIndex);
    }

    changeForItem = (item, i) => {
        const { data, thirIndex, changeThirItem } = this.props;
        data[i].children = item;
        changeThirItem(data, thirIndex);
    }

    render () {
        const { data } = this.props;
        return (
            <div className="sort-content">
                <SortForList
                    axis="y"
                    lockAxis="y"
                    helperClass="sortHelper"
                    data={data}
                    hideSortableGhost={false}
                    lockToContainerEdges={true}
                    onSortEnd={this.onSortEnd}
                    changeForItem={this.changeForItem}
                />
            </div>
        )
    }
}

class SortThirItemDom extends Component {
    state = {
        isShow: true,
    }

    render () {
        const { isShow } = this.state;
        const { data, changeThirItem, thirIndex } = this.props;
        const hasChild = data.children ? (data.children.length > 0) : false;
        return (
            <div className='sort-template-contain'>
                <div className="sort-template-header" style={{ position: 'relative' }}>
                    {data.fieldName}
                    {
                       hasChild &&
                       <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                {
                   hasChild && isShow &&
                    <SortForWrap key={data.followBoardDetailId} changeThirItem={changeThirItem} thirIndex={thirIndex} data={data.children} />
                }
            </div>
        )
    }
}

const SortThirItem = SortableElement(({ data, thirIndex, changeThirItem }) => {
    return (
        <SortThirItemDom key={data.followBoardDetailId} changeThirItem={changeThirItem} thirIndex={thirIndex} data={data} />
    )
});

const SortThirList = SortableContainer(({ data, changeThirItem }) => {
    return (
        <div className="sort-wrap">
            {
                data.map((item, index) => (
                    <SortThirItem key={item.followBoardDetailId} changeThirItem={changeThirItem} index={index} thirIndex={index} data={item} />
                ))
            }
        </div>
    );
});


class SortThirWrap extends Component {
    onSortEnd = ({oldIndex, newIndex}) => {
        const { data, secIndex, changeSecItem } = this.props;
        changeSecItem(arrayMove(data, oldIndex, newIndex), secIndex);
    }

    changeThirItem = (item, i) => {
        const { data, secIndex, changeSecItem } = this.props;
        data[i].children = item;
        changeSecItem(data, secIndex);
    }

    render () {
        const { data } = this.props;
        return (
            <div className="sort-content">
                <SortThirList
                    axis="y"
                    lockAxis="y"
                    helperClass="sortHelper"
                    data={data}
                    hideSortableGhost={false}
                    lockToContainerEdges={true}
                    onSortEnd={this.onSortEnd}
                    changeThirItem={this.changeThirItem}
                />
            </div>
        )
    }
}

class SortSecItemDom extends Component {
    state = {
        isShow: true,
    }

    render () {
        const { isShow } = this.state;
        const { data, changeSecItem, secIndex } = this.props;
        const hasChild = data.children ? (data.children.length > 0) : false;
        return (
            <div className='sort-template-contain'>
                <div className="sort-template-header" style={{ position: 'relative' }}>
                    {data.fieldName}
                    {
                       hasChild &&
                       <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                {
                   hasChild && isShow &&
                    <SortThirWrap key={data.followBoardDetailId} changeSecItem={changeSecItem} secIndex={secIndex} data={data.children} />
                }
            </div>
        )
    }
}

const SortSecItem = SortableElement(({ data, secIndex, changeSecItem }) => {
    return (
        <SortSecItemDom key={data.followBoardDetailId} changeSecItem={changeSecItem} secIndex={secIndex} data={data} />
    )
});

const SortSecList = SortableContainer(({ data, changeSecItem }) => {
    return (
        <div className="sort-wrap">
            {
                data.map((item, index) => (
                    <SortSecItem key={item.followBoardDetailId} changeSecItem={changeSecItem} index={index} secIndex={index} data={item} />
                ))
            }
        </div>
    );
});


class SortSecWrap extends Component {
    onSortEnd = ({oldIndex, newIndex}) => {
        const { data, firIndex, changeItem } = this.props;
        changeItem(arrayMove(data, oldIndex, newIndex), firIndex);
    }

    changeSecItem = (item, i) => {
        const { data, firIndex, changeItem } = this.props;
        data[i].children = item;
        changeItem(data, firIndex);
    }

    render () {
        const { data } = this.props;
        return (
            <div className="sort-content">
                <SortSecList
                    axis="y"
                    lockAxis="y"
                    helperClass="sortHelper"
                    data={data}
                    hideSortableGhost={false}
                    lockToContainerEdges={true}
                    onSortEnd={this.onSortEnd}
                    changeSecItem={this.changeSecItem}
                />
            </div>
        )
    }
}

class SortFirItemDom extends Component {
    state = {
        isShow: true,
    }

    render () {
        const { isShow } = this.state;
        const { data, changeItem, firIndex } = this.props;
        const hasChild = data.children ? (data.children.length > 0) : false;
        return (
            <div className='sort-template-contain'>
                <div className="sort-template-header" style={{ position: 'relative' }}>
                    {data.fieldName}
                    {
                       hasChild &&
                       <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                {
                   hasChild && isShow &&
                    <SortSecWrap key={data.followBoardDetailId} changeItem={changeItem} firIndex={firIndex} data={data.children} />
                }
            </div>
        )
    }
}

const SortFirItem = SortableElement(({ data, firIndex, changeItem }) => {
    return (
        <SortFirItemDom key={data.followBoardDetailId} changeItem={changeItem} firIndex={firIndex} data={data} />
    )
});

const SortFirList = SortableContainer(({ data, changeItem }) => {
    return (
        <div>
            {
                data.map((item, index) => (
                    <SortFirItem key={item.followBoardDetailId} changeItem={changeItem} index={index} data={item} firIndex={index} />
                ))
            }
        </div>
    )
});

class SortTemplate extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    };

    show = data => {
        this.setState({
            data,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    confirm = () => {
        this.setState({ confirmLoading: true });
        const { data } = this.state;
        const { followBoardTypeId } = this.props;
        const params = {};
        const obj = { index: 1 };
        this.loopdata(data, params, obj);
        
        const options = {
            method: 'post',
            url: API_URL.executeMgr.orderInvestigationFollowDetail,
            data: {...params, followBoardTypeId},
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.setState({
                        visible: false,
                        confirmLoading: false,
                    }, () => {
                        this.props.loadData();
                    });
                }
            }),
        };  
        $.sendRequest(options);
    }

    loopdata = (data, params, obj) => {
        data.forEach(item => {
            params[`params[${item.followBoardDetailId}]`] = obj.index;
            obj.index += 1;
            if (item.children && item.children.length > 0) {
                this.loopdata(item.children, params, obj);
            }
        })
    }

    changeItem = (item, index) => {
        const { data } = this.state;
        data[index].children = item;
        this.setState({ data });
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState(({ data }) => ({
            data: arrayMove(data, oldIndex, newIndex),
        }));
    };
    
    render() {
        const { data, visible, confirmLoading } = this.state;
        const { title } = this.props;
        return (
            <Modal
                title={`${title}-排序调整`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="create-modal sort-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
                confirmLoading={confirmLoading}
            >
                <SortFirList
                    axis="y"
                    lockAxis="y"
                    helperClass="sortHelper"
                    hideSortableGhost={false}
                    data={data}
                    onSortEnd={this.onSortEnd}
                    changeItem={this.changeItem}
                />
            </Modal>
        );
    }
}

export default SortTemplate;


// WEBPACK FOOTER //
// ./src/components/common/SortTemplate.js